import React from 'react';
import PropTypes from 'prop-types';
import SelectFieldMultiSelect from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelect';
import TextFilter from 'components/input/TextInput/TextInput';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import EnabledFilter from 'components/form/filters/EnabledFilter';

const NameComponent = <TextFilter
    label='resources.accounts.fields.name'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='name'
/>;

const EmailComponent = <TextFilter
    label='resources.accounts.fields.email'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='email'
/>;

const RoleIdComponent = <SelectFieldMultiSelect
    choices={ [
        {
            id: '3',
            name: 'resources.accounts.roles.reseller',
        },
        {
            id: '15',
            name: 'resources.accounts.roles.provider',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='resources.accounts.fields.role'
    source='role_id'
/>;

const AccountsListFilters = (props) => {
    const filters = {
        basic: {
            is_enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            email: {
                component: EmailComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            name: {
                component: NameComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            role_id: {
                component: RoleIdComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
        advanced: {
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

AccountsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default AccountsListFilters;



// WEBPACK FOOTER //
// ./src/pages/accounts/list/AccountsListFilters.js